import React, { FC, useState, useRef } from 'react'
import { useField, useFormikContext } from 'formik'

import { set } from 'date-fns'

import { FormTimePicker, FormTimePickerRef } from '../Form/FormTimePicker'

import { Element } from '../Element'
import { Stack } from '../Stack'
import { Text } from '../Text'
import { FormField } from '../Form/FormField'
import { FormDatePicker } from '../Form/FormDatePicker'

export const EventFormDatePicker: FC = () => {
  const formContext = useFormikContext()
  const [startField, _startFieldMeta, startFieldHelpers] = useField('startAt')
  const [endField, _endFieldMeta, endFieldHelpers] = useField('endAt')

  const [selectingDate, setSelectingDate] = useState<'start' | 'end'>('start')

  const startAtRef = useRef<FormTimePickerRef>(null)
  const endAtRef = useRef<FormTimePickerRef>(null)

  const values = formContext.values as {
    startAt: Date
    endAt: Date
  }

  const selectDate = (startOrEnd: 'start' | 'end', focus: boolean = true) => {
    if (selectingDate !== startOrEnd) {
      setSelectingDate(startOrEnd)

      if (focus) {
        if (startOrEnd === 'start') {
          if (startAtRef.current) {
            startAtRef.current.focus()
          }
        } else {
          if (endAtRef.current) {
            endAtRef.current.focus()
          }
        }
      }
    }
  }

  return (
    <>
      <Stack gap={2}>
        <FormField
          name='eventDates'
          label='Dates'
          // label={selectingDate === 'start' ? 'Start date' : 'End date'}
          inputWrapperProps={{ direction: 'horizontal' }}
        >
          <FormDatePicker
            selectingDate={selectingDate}
            onChangeStartDate={(newStartDate) => {
              if (newStartDate > endField.value) {
                endFieldHelpers.setValue(
                  set(newStartDate, {
                    hours: values.endAt.getHours(),
                    minutes: values.endAt.getMinutes(),
                  })
                )
              }

              selectDate('end')
            }}
            onChangeEndDate={(newEndDate) => {
              if (newEndDate && newEndDate < startField.value) {
                startFieldHelpers.setValue(
                  set(newEndDate, {
                    hours: values.startAt.getHours(),
                    minutes: values.startAt.getMinutes(),
                  })
                )
              }

              selectDate('start')
            }}
          />
        </FormField>

        <Stack gap={2} direction='horizontal' alignItems='flex-end'>
          <FormField name='startAt' label='Start at'>
            <FormTimePicker
              ref={startAtRef}
              onFocus={() => selectDate('start')}
            />
          </FormField>

          <Element tokens={{ height: 8 }}>
            <Text size={6}>→</Text>
          </Element>

          <FormField name='endAt' label='End at'>
            <FormTimePicker ref={endAtRef} onFocus={() => selectDate('end')} />
          </FormField>
        </Stack>
      </Stack>
    </>
  )
}
